/* ExposureDisplayStatusRenderer.js */

"use strict";

class ExposureDisplayStatusRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("exposure-status-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let prom = new Promise((resolve) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on(
            "ExposureDisplayStatus",
            (this._onExposureDisplayStatusColumn = this._onExposureDisplayStatusColumn.bind(this))
        );
    }

    _onExposureDisplayStatusColumn() {
        this._setExposureDisplayStatusColumn(this._model.getDisplayText());
    }

    _unregisterListeners() {
        this._model.removeAllListeners("ExposureDisplayStatus");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        let prom = new Promise((resolve) => {
            this._setExposureDisplayStatusColumn(this._model.getDisplayText());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setExposureDisplayStatusColumn(text) {
        this._rootElem.textContent = text;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ExposureDisplayStatusRenderer;
